


import { setGetMailingStatisticsScrollerUsersDepositsByUserAction } from '../action';
import { getMailingStatisticsScrollerUsersDepositsByUser } from '../api/getMailingStatisticsScrollerUsersDepositsByUser';

export const setGetMailingStatisticsScrollerUsersDepositsByUser = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await getMailingStatisticsScrollerUsersDepositsByUser({
                ...params,
                status: 'paid'
            });
            const state = getState().mailing.scrollers.deposits_by_user;

            const new_data = {
                ...state,
                [params.login]: data
            }
            dispatch(setGetMailingStatisticsScrollerUsersDepositsByUserAction(new_data))
        } catch (error) {
            alert('Ошибка')
            console.log(error)
        }
    }
}